import React from 'react';
import Card from '../../../../shared/components/Card';

/** 4 cartes statistiques en haut de SecurityLogs (Total / Critiques / Élevés / Moyens). */

export interface SecurityStatsCardsProps {
  stats: {
    total: number;
    bySeverity: Array<{ severity: string; count: number }>;
  };
}

const SecurityLogsStatsCards: React.FC<SecurityStatsCardsProps> = ({ stats }) => {
  const sev = (label: string) => stats.bySeverity.find((s) => s.severity === label)?.count || 0;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <Card className="bg-gradient-to-br from-blue-600/30 to-blue-800/30 border-blue-500/50 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-blue-300 text-sm font-medium mb-1">Total (7 jours)</p>
            <p className="text-4xl font-bold text-white">{stats.total}</p>
          </div>
          <div className="bg-blue-500/20 p-4 rounded-xl">
            <svg className="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
        </div>
      </Card>

      <Card className="bg-gradient-to-br from-red-600/30 to-red-800/30 border-red-500/50 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-red-300 text-sm font-medium mb-1">Critiques</p>
            <p className="text-4xl font-bold text-white">{sev('critical')}</p>
          </div>
          <div className="bg-red-500/20 p-4 rounded-xl">
            <svg className="w-8 h-8 text-red-300" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </Card>

      <Card className="bg-gradient-to-br from-orange-600/30 to-orange-800/30 border-orange-500/50 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-orange-300 text-sm font-medium mb-1">Élevés</p>
            <p className="text-4xl font-bold text-white">{sev('high')}</p>
          </div>
          <div className="bg-orange-500/20 p-4 rounded-xl">
            <svg className="w-8 h-8 text-orange-300" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </Card>

      <Card className="bg-gradient-to-br from-yellow-600/30 to-yellow-800/30 border-yellow-500/50 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-yellow-300 text-sm font-medium mb-1">Moyens</p>
            <p className="text-4xl font-bold text-white">{sev('medium')}</p>
          </div>
          <div className="bg-yellow-500/20 p-4 rounded-xl">
            <svg className="w-8 h-8 text-yellow-300" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SecurityLogsStatsCards;
